import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary'

// Add initialization logging
console.log('Application initializing...')

const renderApp = () => {
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error('Failed to find root element')
  }

  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>,
    )
    console.log('Application rendered successfully')
  } catch (error) {
    console.error('Failed to render application:', error)
    // Show a basic error message if rendering fails completely
    rootElement.innerHTML = `
      <div style="
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
        font-family: system-ui, sans-serif;
        text-align: center;
        padding: 20px;
      ">
        <div>
          <h1 style="color: #ef4444; margin-bottom: 16px;">Failed to load application</h1>
          <p style="color: #666;">Please try refreshing the page. If the problem persists, contact support.</p>
        </div>
      </div>
    `
  }
}

renderApp()
